// Dubai guide: Ramadan workout plan. Must stay distinct from the KL puasa guide.
const content = {
    slug: 'ramadan-workout-plan',
    title: 'Ramadan Workout Plan for Dubai | When and How to Train While Fasting',
    description: 'How to train during Ramadan in Dubai: the best times to work out, a weekly plan, hydration between Iftar and Suhoor, and what to avoid.',
    eyebrow: 'Dubai · Fitness guide',
    h1: 'Ramadan Workout Plan: Training While Fasting in Dubai',
    lead: 'Ramadan does not have to mean a month off training - just a different rhythm. Shorter, lighter sessions at the right time of day keep your progress without draining you.',
    datePublished: '2026-10-03',
    image: 'personal-trainer/personal-trainer.jpg',
    imageAlt: 'Light evening training session during Ramadan',
    summary: {
        title: 'The essentials',
        items: [
            'Best times: 60-90 minutes before Iftar (light work) or 1-2 hours after Iftar (harder work).',
            'Aim to maintain, not to set records.',
            'Hydrate steadily between Iftar and Suhoor.',
            'Many Dubai gyms extend their night hours during Ramadan.',
        ],
    },
    sections: [
        {
            title: 'Choosing your training time',
            cards: [
                { title: 'Before Iftar', body: 'Light sessions - walking, mobility, technique work. You can eat and drink soon after. Keep it under 45 minutes.' },
                { title: 'After Iftar', body: 'The best time for strength work. Eat a light Iftar, wait 1-2 hours, then train.' },
                { title: 'Before Suhoor', body: 'Works for night owls, but cuts into sleep - only if you can rest during the day.' },
            ],
        },
        {
            title: 'A sample week',
            table: {
                columns: [
                    { key: 'day', label: 'Day' },
                    { key: 'session', label: 'Session' },
                    { key: 'when', label: 'When' },
                ],
                rows: [
                    { day: 'Mon', session: 'Full-body strength, 30-40 min', when: 'After Iftar' },
                    { day: 'Tue', session: 'Walk 30 min', when: 'Before Iftar' },
                    { day: 'Wed', session: 'Full-body strength, 30-40 min', when: 'After Iftar' },
                    { day: 'Thu', session: 'Mobility and stretching', when: 'Before Iftar' },
                    { day: 'Fri', session: 'Rest', when: '-' },
                    { day: 'Sat', session: 'Strength or sport, moderate', when: 'After Iftar' },
                    { day: 'Sun', session: 'Easy walk with family', when: 'After Iftar' },
                ],
            },
        },
        {
            title: 'Eating and drinking for training',
            items: [
                'Break the fast with water and dates, then a balanced meal with protein.',
                'Spread water through the evening rather than drinking a lot at once.',
                'At Suhoor, choose slow-release carbs, protein and some salt to hold water.',
                'Go easy on fried food and sugary drinks at Iftar - they make evening sessions harder.',
            ],
        },
        {
            title: 'When not to train',
            paragraphs: [
                'Skip hard sessions during fasting hours, especially in the heat. If you have diabetes, a heart condition, or are pregnant or breastfeeding, talk to your doctor about fasting and exercise before Ramadan begins.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Is it safe to work out while fasting?',
            answer: 'Light activity is generally fine for healthy adults. Save harder sessions for after Iftar when you can drink and refuel.',
        },
        {
            question: 'Will I lose muscle during Ramadan?',
            answer: 'Not if you keep two or three strength sessions a week and eat enough protein between Iftar and Suhoor.',
        },
    ],
    cta: {
        title: 'Train with a plan this Ramadan',
        body: 'Trainers adjust session times to after Iftar and keep intensity right for fasting.',
        href: '/ae/personal-trainer-dubai',
        label: 'Personal trainers in Dubai',
    },
}

export default content
